// extracted by mini-css-extract-plugin
module.exports = {"attachmentDropdown":"ezUIHALN","attachmentButton":"Xwnn4tcg","infoWrapper":"GFjXNwHK","pillLabel":"NBm4ww8_"};